// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/chunk." + {"212":"581c27f6760997283962","434":"8a79f3c999d3dfbef7de","478":"15939c93c40567b4c7b6"}[chunkId] + ".js";
};